var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.19999 2.97498H24.8C26.2667 2.97498 27.4667 4.24998 27.4667 5.80831V8.92498C27.4667 10.0583 26.8 11.475 26.1333 12.1833L20.4 17.5666C19.6 18.275 19.0667 19.6916 19.0667 20.825V26.9166C19.0667 27.7666 18.5333 28.9 17.8667 29.325L16 30.6C14.2667 31.7333 11.8667 30.4583 11.8667 28.1916V20.6833C11.8667 19.6916 11.3333 18.4166 10.8 17.7083L5.73333 12.0416C5.06666 11.3333 4.53333 10.0583 4.53333 9.20831V5.94998C4.53333 4.24998 5.73333 2.97498 7.19999 2.97498Z",
    stroke: "#5F5F5F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5733 2.97498L8 14.1666",
    stroke: "#5F5F5F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.c6934f663f5c4dc79192603d3a75e06e.svg";
export { ForwardRef as ReactComponent };